<template>
	<div></div>
</template>

<script>
	export default {
		name: "jump",
		data() {
			return {
				scene: '', 
				custom_code: '',
				type: 'system',
				data: {}
			}
		},
	mounted() {
		this.scene = this.$route.query.name;
		this.custom_code = this.$route.query.code;
		if (this.scene) {
			this.type = 'system';
			this.deshare();
		} else if (this.custom_code) {
			this.type = 'custom';
			this.scene = this.custom_code;
			this.deshare();
		} else {
			this.gotoIndex()
		}
	},
		methods: {
			deshare() {
				const _this = this;
				this.$api.deshare({code: _this.scene}).then(res => {
				  if (res.status) {
						_this.saveInviteCode(res.data.userShareCode); //存储邀请码
						_this.data = res.data;
						_this.goPage()
				  }else{
						_this.$msg(_this.$t('failed'))
						_this.gotoIndex()
					}
				})
			},
			goPage() {
				console.log(this.data.page == '2')
				switch(this.data.page) {
					case '1': //首页
						this.gotoIndex();
						break;
					case '2': //商品
						this.gotoGoods(this.data.params.goods_id);
						break;
					default:
						this.gotoIndex();
						break;
				}
			},
			//存储邀请码
			saveInviteCode(invite) {
				if (invite && invite != '') {
					if (this.type == 'system') {
						localStorage.setItem('invite', invite);
					} else {
						localStorage.setItem('customcode', invite);
					}
				}
			},
			gotoGoods(id) {
				this.$router.replace({
					name: 'detail',
					params: {goodsId: id}
				})
			},
			//跳转到首页
			gotoIndex() {
				this.$router.replace({
				  path: `/`,
				})
			},
		}
	}
</script>

<style>
</style>